import { isEmptyString } from '../isEmptyString';
export var isValidNumber = function isValidNumber(value) {
  return !isEmptyString(value) && !isNaN(value);
};